var _defs, _rect, _circle, _polygon, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "940fbdf1-ce62-470d-a0b6-797f32ab6e3c",
    "data-name": "Layer 1",
    viewBox: "0 0 1438.9 1438.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".\\37 977268c-8f55-4c3e-b86c-adf39125e83f{fill:#fff;stroke-width:37.5px;}.\\33 c6911f5-e6ae-49b1-baa6-caae7baea141,.\\37 977268c-8f55-4c3e-b86c-adf39125e83f{stroke:#39526e;stroke-linecap:round;stroke-miterlimit:10;}.\\33 c6911f5-e6ae-49b1-baa6-caae7baea141{fill:none;stroke-width:50px;}.\\39 50fd524-0a06-4cfa-918e-b05cef729ad7{fill:#39526e;}.\\36 ede7224-fc5f-4201-99b4-658aa2ef808e{fill:#eea320;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_BaleWeight-KG_1500x1500_Outline-Rev") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "7977268c-8f55-4c3e-b86c-adf39125e83f",
    x: 18.75,
    y: 18.75,
    width: 1401.4,
    height: 1401.4,
    rx: 253.52,
    ry: 253.52
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "3c6911f5-e6ae-49b1-baa6-caae7baea141",
    cx: 735.97,
    cy: 457.49,
    r: 140.95
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "950fd524-0a06-4cfa-918e-b05cef729ad7",
    points: "444.04 558.45 1032.2 557.87 1171.28 1170.81 301.26 1171.67 444.04 558.45"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "6ede7224-fc5f-4201-99b4-658aa2ef808e",
    d: "M558.82,1084.62V811.53H603.9V933.09l91.54-121.56h60.93L671.93,918l88.91,166.66H702.33L640.55,956.28l-36.65,45.81v82.53Z",
    transform: "translate(-34.42 -28.55)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "6ede7224-fc5f-4201-99b4-658aa2ef808e",
    d: "M888.35,984.4V938.2h97.43V1047q-14.71,17.33-41.73,29.8t-54.21,12.48q-33.15,0-58.49-16.3t-40.14-48.8q-14.82-32.51-14.81-76.47,0-45.08,15-77.12t38.94-47.88q23.92-15.83,57.28-15.83,40,0,64.17,20.4t31,59.89L938.09,897.4q-5-21-18.44-32.23t-32-11.17q-28.87,0-46.76,22.45T823,944.9q0,49.38,19.37,75.08,16.57,22.17,44.9,22.16,13.21,0,27.47-6.22a85.53,85.53,0,0,0,25.43-17V984.4Z",
    transform: "translate(-34.42 -28.55)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.473dd5012857224d2a2f71ba7d2bba57.svg";
export { ForwardRef as ReactComponent };